import "../../styles/circleProgress.css";

interface IProps {
    size: number;
    margin?: string;
    padding?: number;
    visibled: boolean;
    marginLeft?: number;
}

const CircleProgress = ({ size, visibled, marginLeft, margin, padding }: IProps) => {
    if (!visibled) return null;
    return (
        <div
            className="cr-loader"
            style={{
                margin: margin,
                width: size + "px",
                height: size + "px",
                padding: padding + "px",
                borderWidth: size / 5 + "px",
                marginLeft: marginLeft + "px",
            }}
        ></div>
    );
};

export default CircleProgress;
